import { createContext, useContext, useState, useEffect } from 'react';

const BookingDraftContext = createContext({});

export const useBookingDraft = () => {
  const context = useContext(BookingDraftContext);
  if (!context) {
    throw new Error('useBookingDraft must be used within BookingDraftProvider');
  }
  return context;
};

export const BookingDraftProvider = ({ children }) => {
  const [draft, setDraft] = useState(null);

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('booking_draft');
    if (stored) {
      try {
        setDraft(JSON.parse(stored));
      } catch (error) {
        console.error('Failed to parse booking draft:', error);
        localStorage.removeItem('booking_draft');
      }
    }
  }, []);

  // Save to localStorage whenever draft changes
  useEffect(() => {
    if (draft) {
      localStorage.setItem('booking_draft', JSON.stringify(draft));
    } else {
      localStorage.removeItem('booking_draft');
    }
  }, [draft]);

  const updateDraft = (data) => {
    setDraft((prev) => {
      const updated = {
        ...prev,
        ...data,
      };
      // Auto-save to localStorage
      if (updated) {
        localStorage.setItem('booking_draft', JSON.stringify(updated));
      }
      return updated;
    });
  };

  const clearDraft = () => {
    setDraft(null);
    localStorage.removeItem('booking_draft');
  };

  const setFullDraft = (data) => {
    setDraft(data);
  };

  return (
    <BookingDraftContext.Provider
      value={{
        draft,
        updateDraft,
        clearDraft,
        setFullDraft,
      }}
    >
      {children}
    </BookingDraftContext.Provider>
  );
};
